/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:inline-block;overflow:hidden}caroo-resource[_ngcontent-%COMP%]{width:100%;height:100%;border-radius:1000px}"];
export { styles as styles };
